













import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'BravadoInput',
  props: {
    value: {
      type: String,
      default: '',
      required: false,
    } as PropOptions<string>,
    error: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
  computed: {
    containerClass(): Record<string, boolean> {
      return {
        'bravado-input__container flex items-center': true,
        'bravado-input__container--error': !!this.error,
      };
    },
    inputProps(): Record<string, unknown> {
      return {
        ref: 'input',
        autocomplete: 'off',
        class: 'bravado-input__field mr3 ml2 w100',
        value: this.value,
        ...this.$attrs,
      };
    },
    inputListeners(): Record<string, Function> {
      return {
        input: this.handleInput,
        focus: this.handleFocus,
        blur: this.handleBlur,
      };
    },
  },
  methods: {
    handleIconClick(): void {
      this.$emit('handleIconClick');
      if (this.$refs.input) (this.$refs.input as HTMLElement).focus();
    },
    blur(): void {
      (this.$refs.input as HTMLTextAreaElement).blur();
    },
    focus(): void {
      (this.$refs.input as HTMLTextAreaElement).focus();
    },
    handleInput(event: Event): void {
      const target = event.target as HTMLInputElement | HTMLTextAreaElement;

      this.$emit('input', target.value);
    },
    handleFocus(event: Event): void {
      this.$emit('focus', event);
    },
    handleBlur(event: Event): void {
      this.$emit('blur', event);
    },
  },
});
